export const SET_VALUE = (state, [key, value]) => {
  state[key] = value
}
